/*
 * @Author: cn1994
 * @Date: 2025-03-13 13:44:34
 * @LastEditors: cn1994
 * @LastEditTime: 2025-03-18 17:19:05
 * @Description: file content
 */
const routes = [
  {
    path: "/instForeign",
    name: "instForeign",
    meta: {
      title: "在线外教",
      volcengine: true
    },
    component: () => import("@/pages/instForeign/manage/index.vue")
  },
  {
    path: "/instForeign/appointment",
    name: "instForeign/appointment",
    meta: {
      title: "去约课",
      volcengine: true
    },
    component: () => import("@/pages/instForeign/appointment/index.vue")
  },
];
export default routes;
